<template>
  <div>
    <!-- <div class="d-flex justify-center align-center"> -->
      <v-card elevation="0" style="height: calc(100vh - 64px); align-items: center; display: flex;">
        <v-card-text>
          <v-row class="align-center" style="justify-content: center;">
            <v-col cols="12" md="3" v-for="(item, index) in menu" :key="index">
              <v-hover v-slot="{ hover }">
                <v-card min-width="180" :to="item.link" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="128">
                      <v-icon size="100" :color="index === 0 ? '#F06292' : index === 1 ? '#4DD0E1' : '#F57C00'">
                        {{ item.icon }}
                      </v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    {{ item.label }}
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <!-- <v-col cols="12" md="2">
              <v-hover v-slot="{ hover }">
                <v-card min-width="180" class="rounded-lg" :to="'/ake/music'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="128">
                      <v-icon size="100" color="#D400B8">mdi-cellphone</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    AKE
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col> -->
          </v-row>
        </v-card-text>
      </v-card>
    <!-- </div> -->
  </div>
</template>

<script>
import { TokenService } from "@/service/Storage.Service";
export default {
  name: "indexApp",
  data() {
    return {};
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    token() {
      return this.$store.state.token;
    },
    menu () {
        let menu = []
        console.log(this.$store.state.menu)
        this.$store.state.menu.map((item, index) => {
          console.log((item.link).split('-').join('/'))
          if(((item.link).split('-').join('/')).split('/')[1] === "master") {
            // console.log(item.sub_menu)
            menu.push(item)
          }
          // return item
        })
        // this.$router.push({ path: `${menu[0].link}` })
        // this.tab = 0
        return menu
      }
  },
  mounted() {
  },

  methods: {
    logout() {
      TokenService.removeToken();
      window.location = "/login";
    },
  },
};
</script>

<style>
</style>